import {Action} from '@ngrx/store';

export const GET_DASHBOARD_DETAILS = '[Dashboard] Get Dashboard Details';
export const GET_DASHBOARD_DETAILS_SUCCESS = '[Dashboard] Get Dashboard Details Success';
export const GET_DASHBOARD_DETAILS_ERROR = '[Dashboard] Get Dashboard Details Error';


export class GetDashboardDetails implements Action {
  readonly type = GET_DASHBOARD_DETAILS;
  
  constructor(public payload: any) {
  }
}

export class GetDashboardDetailsSuccess implements Action {
  readonly type = GET_DASHBOARD_DETAILS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetDashboardDetailsError implements Action {
  readonly type = GET_DASHBOARD_DETAILS_ERROR;

  constructor(public payload: any) {
  }
}


export type DashboardAction = GetDashboardDetails
  | GetDashboardDetailsSuccess
  | GetDashboardDetailsError


// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/actions/dashboard.action.ts